import IconAssess from "@material-ui/icons/Assessment";
import { Button as DefaultButton } from "ra-ui-materialui/lib/button";
import React, { useCallback } from "react";
import { Parser } from "json2csv";
import fileDownload from "js-file-download";

interface IPassengerReportButton {
  customGetList: any;
  listCtx: any;
  notify: any;
}

const PassengerReportButton = ({
  customGetList,
  listCtx,
  notify,
}: IPassengerReportButton) => {
  const downloadCSV = useCallback(async () => {
    const res = await customGetList("assignments/passengerReport", {
      pagination: { page: 1, perPage: 10000 },
      sort: { field: "", order: "" },
      filter: {
        EstimatedStartedAt: listCtx.filterValues.EstimatedStartedAt,
        SchoolId: listCtx.filter.SchoolId,
        BusSchedulePlanId: listCtx.filterValues.BusSchedulePlanId,
        MultipleStatus: ["Ended", "ForceEnded", "EndedByAdmin"],
      },
    });

    if (res.data.length === 0) {
      notify("There are no ended assignment.", "warning");
      return;
    }

    const parser = new Parser();

    fileDownload(
      parser.parse(res.data),
      `Passenger Report ${res.data[0] ? res.data[0].schoolName : ""} ${
        listCtx.filterValues.EstimatedStartedAt
      }.csv`
    );
  }, [listCtx, customGetList]);

  return (
    <DefaultButton onClick={downloadCSV}>
      <>
        <IconAssess />
        <span>Download Passenger Report</span>
      </>
    </DefaultButton>
  );
};

export default PassengerReportButton;
